import { Button } from '@chakra-ui/react';
import { type FC } from 'react';

import { Text } from '@/components/Typography/Text';

import { BUTTON_SIZES, DISABLED_OPACITY } from '../constants';
import type { ButtonPrimaryProps } from './types';
import { colors } from '@/styles/theme/constants';

export const ButtonPrimary: FC<ButtonPrimaryProps> = ({
  children,
  textVariant,
  size = 'sm',
  shadowed = true,
  variant,
  ...props
}) => {
  return (
    <Button
      variant="solid"
      height={BUTTON_SIZES[size].height}
      minH="unset"
      borderRadius="8px"
      bg={variant === 'outline' ? 'shade09' : 'red03'}
      boxShadow={shadowed && variant !== 'outline' ? '8px 8px 16px 0px rgba(237, 34, 39, 0.16)' : undefined}
      border={variant === 'outline' ? `solid 1px ${colors.red03}` : undefined}
      _focus={{
        outline: 'none',
        bg: variant === 'outline' ? 'shade09' : 'red03',
      }}
      _hover={{
        bg: variant === 'outline' ? 'shade09' : 'red03',
      }}
      _disabled={{
        color: variant === 'outline' ? 'red03' : 'shade09',
        opacity: DISABLED_OPACITY,
        cursor: 'not-allowed',
        _focus: {
          outline: 'none',
          bg: 'red03',
        },
        _hover: {
          bg: 'red03',
        },
      }}
      {...props}
    >
      <Text
        variant={textVariant ?? BUTTON_SIZES[size].fontVariant}
        color={variant === 'outline' ? 'red03' : 'shade09'}
      >
        {children}
      </Text>
    </Button>
  );
};

export * from './types';
